import React from "react";

export interface EntryOption<T> {
  value: T;
  label: string;
  sublabel?: string;
}

interface OptionGridProps<T> {
  options: EntryOption<T>[];
  selected: T | null;
  onSelect: (value: T) => void;
  /** Tighter columns, for short labels like a penalty length. */
  narrow?: boolean;
}

/** Wrapping choice buttons, used for period, penalty type and penalty length. */
function OptionGrid<T extends string | number>({
  options,
  selected,
  onSelect,
  narrow = false,
}: OptionGridProps<T>) {
  return (
    <div className={`ee-option-grid${narrow ? " ee-option-grid--narrow" : ""}`}>
      {options.map((option) => {
        const isSelected = option.value === selected;

        return (
          <button
            key={String(option.value)}
            type="button"
            className={`ee-option-btn${
              isSelected ? " ee-option-btn--selected" : ""
            }`}
            aria-pressed={isSelected}
            onClick={() => onSelect(option.value)}
          >
            <span className="ee-option-label">{option.label}</span>
            {option.sublabel && (
              <span className="ee-option-sublabel">{option.sublabel}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default OptionGrid;
